export default "__VITE_ASSET__D4N5HPLA__"